const carouselSizes = {
    extraSmall: 150,
    small: 250,
    medium: 350,
    large: 350,
};

export default carouselSizes;
